// extracted by mini-css-extract-plugin
module.exports = {"flexColumn":"_2RnCApwm","flexColumnList":"_2ChYGrW-","flexRow":"_1wLQ8Y0o","salesInfoItem":"_2sJcMoAp","salesLabel":"_3JwMrAa_","salesInfoAmount":"_1XFs8Eo_","summary":"_1lVP7jRk","marginBottom":"_13Ec9psL"};
    if(module.hot) {
      // 1746735798866
      var cssReload = require("!../../../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  